import { render, staticRenderFns } from "./BotoesAcoes.vue?vue&type=template&id=931b53d2"
import script from "./BotoesAcoes.vue?vue&type=script&lang=js"
export * from "./BotoesAcoes.vue?vue&type=script&lang=js"
import style0 from "./BotoesAcoes.vue?vue&type=style&index=0&id=931b53d2&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports